// 'use client';

// import React from 'react';
// import { ShoppingCart, Ticket, RefreshCcw } from 'lucide-react';

// const OtherServices: React.FC = () => {
//   return (
//     <div className="services-wrapper">
      
//       {/* عنوان بخش */}
//       <h2 className="section-title">سایر خدمات ایرانیجا</h2>

//       {/* کارت اصلی */}
//       <div className="services-card">
        
//         {/* آیتم سمت راست: پشتیبانی */}
//         <div className="service-item">
//           {/* گروه محتوا (آیکون و متن) */}
//           <div className="content-group">
//              <div className="icon-box cart-icon-style">
//                 <ShoppingCart size={24} strokeWidth={2} />
//              </div>
//              <span className="service-text">پشتیبانی و پیگیری رزرو</span>
//           </div>
//           {/* دکمه سبز */}
//           <button className="action-btn green-btn">کلیک کنید</button>
//         </div>

//         {/* خط جدا کننده عمودی */}
//         <div className="divider"></div>

//         {/* آیتم سمت چپ: استرداد */}
//         <div className="service-item">
//           <div className="content-group">
//              <div className="icon-box refund-icon-style">
//                 <div style={{ position: 'relative', display: 'flex' }}>
//                     <Ticket size={24} strokeWidth={2} className="ticket-icon" />
//                     <div className="refresh-badge">
//                         <RefreshCcw size={10} strokeWidth={4} />
//                     </div>
//                 </div>
//              </div>
//              <span className="service-text">استرداد رزرو</span>
//           </div>
//           {/* دکمه آبی تیره */}
//           <button className="action-btn blue-btn">کلیک کنید</button>
//         </div>

//       </div>

//       <style jsx>{`
//         .services-wrapper {
//           width: 100%;
//           max-width: 1250px;
//           margin: 40px auto;
//           padding: 0 15px;
//           direction: rtl;
//         }

//         .section-title {
//           text-align: right;
//           font-size: 22px;
//           font-weight: 800;
//           color: #374151;
//           margin-bottom: 25px;
//         }

//         .services-card {
//           background: white;
//           border: 1px solid #cbd5e1;
//           border-radius: 20px;
//           padding: 12px 20px;
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           min-height: 90px;
//           box-shadow: 0 1px 2px rgba(0,0,0,0.05);
//         }

//         .service-item {
//           flex: 1;
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           padding: 0 10px;
//         }

//         .content-group {
//             display: flex;
//             align-items: center;
//             gap: 15px;
//         }

//         .service-text {
//             font-size: 16px;
//             font-weight: 700;
//             color: #333;
//             line-height: 1.4;
//         }

//         .icon-box {
//             width: 48px;
//             height: 48px;
//             border-radius: 12px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             flex-shrink: 0;
//             transition: all 0.3s ease;
//         }

//         .cart-icon-style {
//             background-color: #f0f9ff;
//             border: 1.5px solid #2563eb;
//             color: #1e293b;
//         }

//         .refund-icon-style {
//             background-color: #e0f2fe;
//             border: none;
//             color: #374151;
//         }
        
//         .ticket-icon {
//             opacity: 0.8;
//             transform: rotate(-10deg);
//         }

//         .refresh-badge {
//             position: absolute;
//             bottom: -5px;
//             right: -5px;
//             background: white;
//             color: #16a34a;
//             width: 16px;
//             height: 16px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             border-radius: 50%;
//             box-shadow: 0 1px 3px rgba(0,0,0,0.15);
//         }

//         .action-btn {
//             padding: 10px 30px;
//             border-radius: 10px;
//             color: white;
//             border: none;
//             font-family: inherit;
//             font-size: 13px;
//             font-weight: 700;
//             cursor: pointer;
//             transition: opacity 0.2s;
//             white-space: nowrap;
//             box-shadow: 0 2px 4px rgba(0,0,0,0.1);
//         }
        
//         .action-btn:hover { opacity: 0.9; }
//         .green-btn { background-color: #65a30d; }
//         .blue-btn { background-color: #0033a0; }

//         .divider {
//             width: 1px;
//             height: 50px;
//             background-color: #cbd5e1;
//             margin: 0 20px;
//         }

//         /* --- تنظیمات موبایل برای تطابق دقیق با تصویر --- */
//         @media (max-width: 768px) {
//             .section-title {
//                 text-align: center;
//                 font-size: 18px;
//                 margin-bottom: 20px;
//             }

//             .services-card {
//                 /* برخلاف کد قبلی، اینجا نباید column باشد */
//                 flex-direction: row; 
//                 align-items: stretch; /* ارتفاع آیتم‌ها یکسان شود */
//                 padding: 25px 10px;
//                 gap: 5px;
//             }

//             .service-item {
//                 /* چیدمان داخلی هر کارت عمودی شود */
//                 flex-direction: column; 
//                 justify-content: space-between;
//                 text-align: center;
//                 padding: 0 5px;
//                 height: 100%;
//             }

//             .content-group {
//                 /* آیکون بالای متن قرار بگیرد */
//                 flex-direction: column; 
//                 justify-content: center;
//                 gap: 12px;
//                 margin-bottom: 15px;
//                 width: 100%;
//             }

//             .icon-box {
//                 /* آیکون‌ها در موبایل کمی بزرگتر و برجسته‌تر */
//                 width: 60px;
//                 height: 60px;
//                 margin-bottom: 5px;
//             }

//             .service-text {
//                 font-size: 14px;
//                 /* ارتفاع ثابت برای اینکه اگر متن دو خطی شد دکمه‌ها هم‌تراز بمانند */
//                 min-height: 42px; 
//                 display: flex;
//                 align-items: center;
//                 justify-content: center;
//             }

//             .divider {
//                 /* خط وسط باید عمودی بماند اما ارتفاعش خودکار تنظیم شود */
//                 width: 1px;
//                 height: auto;
//                 margin: 10px 5px;
//                 background-color: #cbd5e1;
//             }
            
//             .action-btn {
//                 width: 100%; /* دکمه تمام عرض */
//                 padding: 12px 0;
//                 font-size: 14px;
//             }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default OtherServices;
'use client';

import React from 'react';
import { ShoppingCart, Ticket, RefreshCcw } from 'lucide-react';
import SeoHeading from '../seo/SeoHeading';
import { HomeSeoSlots, getHomeSlot } from '../../../src/lib/seo/home-headings';

type Props = {
  headings: HomeSeoSlots;
};

const OtherServices: React.FC<Props> = ({ headings }) => {
  const sectionTitle = getHomeSlot(headings, 'otherServicesTitle');
  const supportTitle = getHomeSlot(headings, 'otherServiceSupportTitle');
  const refundTitle = getHomeSlot(headings, 'otherServiceRefundTitle');

  return (
    <div className="services-wrapper">
      <SeoHeading slot={sectionTitle} className="other-services-section-title" />

      <div className="services-card">
        <div className="service-item">
          <div className="content-group">
            <div className="icon-box cart-icon-style">
              <ShoppingCart size={24} strokeWidth={2} />
            </div>
            <SeoHeading slot={supportTitle} className="other-services-service-text" />
          </div>
          <button className="action-btn green-btn">کلیک کنید</button>
        </div>

        <div className="divider"></div>

        <div className="service-item">
          <div className="content-group">
            <div className="icon-box refund-icon-style">
              <div style={{ position: 'relative', display: 'flex' }}>
                <Ticket size={24} strokeWidth={2} className="ticket-icon" />
                <div className="refresh-badge">
                  <RefreshCcw size={10} strokeWidth={4} />
                </div>
              </div>
            </div>
            <SeoHeading slot={refundTitle} className="other-services-service-text" />
          </div>
          <button className="action-btn blue-btn">کلیک کنید</button>
        </div>
      </div>

      <style jsx>{`
        .services-wrapper {
          width: 100%;
          max-width: 1250px;
          margin: 40px auto;
          padding: 0 15px;
          direction: rtl;
        }

        :global(.other-services-section-title) {
          text-align: right;
          font-size: 22px;
          font-weight: 800;
          color: #374151;
          margin-bottom: 25px;
          display: block;
        }

        .services-card {
          background: white;
          border: 1px solid #cbd5e1;
          border-radius: 20px;
          padding: 12px 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          min-height: 90px;
          box-shadow: 0 1px 2px rgba(0,0,0,0.05);
        }

      .service-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}

.content-group {
  display: flex;
  align-items: center;
  gap: 15px;
}

:global(.other-services-service-text) {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  line-height: 1.4;
  margin: 0;
  display: inline-block;
}

        .icon-box {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: all 0.3s ease;
        }

        .cart-icon-style {
          background-color: #f0f9ff;
          border: 1.5px solid #2563eb;
          color: #1e293b;
        }

        .refund-icon-style {
          background-color: #e0f2fe;
          border: none;
          color: #374151;
        }

        .ticket-icon {
          opacity: 0.8;
          transform: rotate(-10deg);
        }

        .refresh-badge {
          position: absolute;
          bottom: -5px;
          right: -5px;
          background: white;
          color: #16a34a;
          width: 16px;
          height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          box-shadow: 0 1px 3px rgba(0,0,0,0.15);
        }

        .action-btn {
          padding: 10px 30px;
          border-radius: 10px;
          color: white;
          border: none;
          font-family: inherit;
          font-size: 13px;
          font-weight: 700;
          cursor: pointer;
          transition: opacity 0.2s;
          white-space: nowrap;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }

        .action-btn:hover {
          opacity: 0.9;
        }

        .green-btn {
          background-color: #65a30d;
        }

        .blue-btn {
          background-color: #0033a0;
        }

        .divider {
          width: 1px;
          height: 50px;
          background-color: #cbd5e1;
          margin: 0 20px;
        }

        @media (max-width: 768px) {
          :global(.other-services-section-title) {
            text-align: center;
            font-size: 18px;
            margin-bottom: 20px;
          }

          .services-card {
            flex-direction: row;
            align-items: stretch;
            padding: 25px 10px;
            gap: 5px;
          }

          .service-item {
            flex-direction: column;
            justify-content: space-between;
            text-align: center;
            padding: 0 5px;
            height: 100%;
          }

          .content-group {
            flex-direction: column;
            justify-content: center;
            gap: 12px;
            margin-bottom: 15px;
            width: 100%;
          }

          .icon-box {
            width: 60px;
            height: 60px;
            margin-bottom: 5px;
          }

          :global(.other-services-service-text) {
            font-size: 14px;
            min-height: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
          }

          .divider {
            width: 1px;
            height: auto;
            margin: 10px 5px;
            background-color: #cbd5e1;
          }

          .action-btn {
            width: 100%;
            padding: 12px 0;
            font-size: 14px;
          }
        }
      `}</style>
    </div>
  );
};

export default OtherServices;